import RestResource from '../rest.service';

export default class PlotsRainsService extends RestResource {
  setPlot(plotId) {
    //set parent -> it will show the Plot that belong to one Rain
    this.parents = [];
    this.parents.push(plotId);
    return this;
  }

  map(entity) {
    return {
      date: entity.date,
      description: entity.description,
      quantity: entity.quantity,
    };
  }

  constructor() {
    //Call parent's constructor to set this.resource
    super('plots/$0/rain-measures');
  }
}
